module.exports = __webpack_public_path__ + "img/logo.16425416.png";